import { SpaceSourceType } from '../../types';

// The link picker only supports web URLs as sources. This function will be updated in the future
// to convert sources from the picker to sources that match the spaces APIs
export function detectSourceType(_url: string): SpaceSourceType {
	return SpaceSourceType.WebPage;
}
